'use client';
import React, { FC, PropsWithChildren, useState } from 'react';

import './styles.scss';
import { useDeviceSize } from '@/hooks/useDeviceSize';

interface SliderProps {
  isOpened: boolean;
}
const Slider: FC<PropsWithChildren<SliderProps>> = ({ children, isOpened }) => {
  return (
    <div className="featuresMainCl">
      <div className="horizontalScrollContainer">
        <div id="slide-container" className={`featuresContent ${isOpened ? 'open' : ''} `}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Slider;
